import { Group, Stack, Text, ThemeIcon } from '@mantine/core';

export function Logo({ compact = false }: { compact?: boolean }) {
  return (
    <Group gap={10} wrap="nowrap">
      <ThemeIcon size={34} radius="md" variant="filled" aria-hidden>
        <svg viewBox="0 0 64 64" width="22" height="22">
          <path d="M16 46V18h6l10 14 10-14h6v28h-7V30l-9 12-9-12v16z" fill="currentColor" />
        </svg>
      </ThemeIcon>
      {!compact && (
        <Stack gap={0}>
          <Text fw={700} lh={1.15} fz="md">
            MExP
          </Text>
          <Text c="dimmed" fz={11} lh={1.2}>
            Makin Laboratories
          </Text>
        </Stack>
      )}
    </Group>
  );
}
